export const dashboard = {
  title: 'Dashboard',
  subtitle: 'Overview of your AI calling business data and activities',
  
  //  Plan & Balance
  currentPlan: 'Current Plan',
  planExpiry: 'Plan Expiry',
  callBalance: 'Call Balance',
  usedToday: 'Used Today',
  minutes: 'min',
  
  //  KPI
  todayKPI: "Today's KPI",
  totalCalls: 'Total Calls',
  successCalls: 'Success Calls',
  successRate: 'Success Rate',
  avgDuration: 'Avg Duration',
  calls: 'calls',
  rate: 'rate',
  
  //  Trend
  weeklyTrend: 'Last 7 Days Trend',
  
  //  Recent Activity
  recentTasks: 'Recent Tasks',
  recentCalls: 'Recent Calls',
  taskName: 'Task Name',
  task: 'Task',
  result: 'Result',
  duration: 'Duration',
  statusActive: 'Active',
};
